import { klaviyoTriggerPopup } from "./apps/klaviyo-trigger-popup";
import { cartDrawer } from "./cart-drawer";
import { paymentMessaging } from "./payment-messaging";
import { productForm } from "./product-form";
import { productGridItem } from "./product-grid-item";
import { popup } from "./utilities/popup";
import { tooltip } from "./utilities/tooltip";

(function () {
  cartDrawer.init();
  klaviyoTriggerPopup.init();
  paymentMessaging.init();
  productForm.init();
  productGridItem.init();
  popup.init();
  tooltip.init();
})();

document.addEventListener("DOMContentLoaded", () => {
  const badgeBoxes = document.querySelectorAll(".badge-box");

  badgeBoxes.forEach((badge) => {
    if (badge instanceof HTMLElement) {
      badge.innerHTML = removeExclamationMark(badge.innerHTML);
    }
  });
});
document.addEventListener("rebuy.ready", (e) => {
  setTimeout(() => {
    const badgeBoxes = document.querySelectorAll(".rebuy-product-badge");

    badgeBoxes.forEach((badge) => {
      if (badge instanceof HTMLElement) {
        badge.innerHTML = removeExclamationMark(badge.innerHTML);
      }
    });
  }, 1000);
});

function removeExclamationMark(text: string) {
  const t = text.trim();
  if (t.endsWith("!")) {
    return t.slice(0, -1);
  }
  return t;
}
